import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "seniority-level" }
const _hoisted_2 = { class: "seniority-level__title" }
const _hoisted_3 = ["value", "checked", "data-testid"]
const _hoisted_4 = { class: "" }

import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import {SeniorityLevel} from '@/profile-creation-wizard/components/for-completion/domain/types';
    import {computed} from 'vue';
    import {useTranslation} from '@malt/vue3-use';
    import store from '@/profile-creation-wizard/store';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SeniorityLevelSelection',
  props: {
    seniorityLevel: {}
  },
  emits: ["seniority-level-selected"],
  setup(__props: any, { emit: __emit }) {

    const {msg} = useTranslation();
    const isFunnelStrategy = computed(() => store.state.isFunnelStrategy);

    const seniorityTitle = computed(() =>
        isFunnelStrategy.value
            ? msg('profile.creation.completion.wizard.v2.seniority.title')
            : msg('profile.creation.completion.wizard.seniority.title'),
    );

    const props = __props;

    const emit = __emit;

    const seniorityLevels: SeniorityLevel[] = Object.values(SeniorityLevel);

    function selectSeniorityLevel(customEvent: CustomEvent): void {
        /*
        workaround: @joy-selectable-item-group-change event triggers one time for nothing
        if item A is selected and I select item B -> event1 {checked: false, value: B}, event2 {checked: true, value: B}
        event1 should not be there
         */
        if (eventShouldBeIgnored(customEvent)) {
            return;
        }
        const selectedSeniorityLevel = customEvent.detail.checked ? customEvent.detail.value : null;

        emit('seniority-level-selected', selectedSeniorityLevel);
    }

    function eventShouldBeIgnored(customEvent: CustomEvent) {
        return !customEvent.detail.checked && customEvent.detail.value != props.seniorityLevel;
    }

    function seniorityLevelId(seniorityLevel: SeniorityLevel): string {
        return `profile-creation-seniority-level-${seniorityLevel.toLowerCase()}`;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(seniorityTitle.value), 1),
    _createVNode(StepItemTitle, {
      "is-optional": true,
      "data-testid": "profile-creation-seniority-title"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.seniority.subtitle')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("joy-selectable-item-group", {
      "full-width": "",
      "data-testid": "freelancer-signup-completion-privacy-selectable-seniority-level",
      onJoySelectableItemGroupChange: selectSeniorityLevel
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(seniorityLevels), (seniorityLevel) => {
        return (_openBlock(), _createElementBlock("joy-selectable-item", {
          key: seniorityLevel,
          value: seniorityLevel,
          checked: seniorityLevel === props.seniorityLevel,
          "data-testid": seniorityLevelId(seniorityLevel)
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(msg)(`profile.creation.completion.wizard.details.seniority.${seniorityLevel}`)), 1)
        ], 8, _hoisted_3))
      }), 128))
    ], 32)
  ]))
}
}

})